<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__title">
      Прошу удаленно выдать выписку из реестра уведомлений о залоге движимого
      имущества в виде
    </div>

    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <v-radio-group v-model="extractType" column>
              <v-radio label="краткой выписки (любому лицу)" :value="'SHORT'" />
              <v-radio
                label="краткой выписки (залогодателю или залогодержателю)"
                :value="'OVERALL'"
              />
              <div v-if="extractType === 'OVERALL'" class="form-base--inner">
                <v-container>
                  <v-row>
                    <v-col class="pt-0">
                      <div class="form-base__label text-color-base">
                        Лицо, обратившееся за получением сведений, является:
                      </div>
                      <v-radio-group v-model="role" column class="mt-0">
                        <v-radio
                          label="залогодателем;"
                          :value="'APPLICANT_PLEGOR'"
                        />
                        <v-radio
                          label="залогодержателем;"
                          :value="'APPLICANT_PLEDGEE'"
                        />
                        <v-radio
                          label="управляющим залогом."
                          :value="'APPLICANT_PLEDGE_MANAGER'"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <v-radio
                label="расширенной выписки (залогодателю или залогодержателю)"
                :value="'EXTENDED'"
              />
              <div v-if="extractType === 'EXTENDED'" class="form-base--inner">
                <v-container>
                  <v-row>
                    <v-col class="pt-0">
                      <div class="form-base__label text-color-base">
                        Лицо, обратившееся за получением сведений, является:
                      </div>
                      <v-radio-group v-model="role" column class="mt-0">
                        <v-radio
                          label="залогодателем;"
                          :value="'APPLICANT_PLEGOR'"
                        />
                        <v-radio
                          label="залогодержателем;"
                          :value="'APPLICANT_PLEDGEE'"
                        />
                        <v-radio
                          label="управляющим залогом."
                          :value="'APPLICANT_PLEDGE_MANAGER'"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import { RuzdiStep } from '@/constants';

export default {
  name: 'ExtractType',
  components: {
    Footer,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    invalidFields: [],
    extractType: 'SHORT',
    role: 'APPLICANT_PLEGOR',
  }),
  created() {
    this.prefillDraft();
  },
  methods: {
    touchFields() {},

    assemblyModel() {
      const model = {
        extractType: this.extractType,
      };
      model.role = this.extractType !== 'SHORT' ? this.role : null;
      return model;
    },

    prefillDraft() {
      if (!ServicesModule.statement.ruzdiDetails?.extractType) {
        return;
      }

      this.extractType = ServicesModule.statement.ruzdiDetails.extractType;
      if (
        this.extractType !== 'SHORT' &&
        ServicesModule.statement.subjects.applicant?.role
      ) {
        this.role = ServicesModule.statement.subjects.applicant.role;
      }
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: RuzdiStep.EXTRACT_TYPE,
      });
    },
  },
};
</script>
